import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Image } from '../../models/product.model';

@Component({
  standalone: true,
  selector: 'base-images',
  templateUrl: './images.component.html',
  styleUrls: ['./images.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule]
})
export class ImagesComponent {



  readonly featuredImages = input<Image[]>([]);
}

